import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducer';
export var composedEnhancer = applyMiddleware(thunkMiddleware);
export var store = createStore(rootReducer, composedEnhancer);
